/**
 * Main layout component
 */
import { ReactNode } from 'react'
import { Navbar } from './Navbar'
import { Sidebar } from './Sidebar'
import { CommandPalette, CommandPaletteProvider, useCommandPalette } from '../CommandPalette'

interface LayoutProps {
  children: ReactNode
}

function LayoutContent({ children }: LayoutProps) {
  const { isOpen, close } = useCommandPalette()

  return (
    <div className="min-h-screen bg-gray-100">
      <Navbar />
      {/* Floating sidebar - doesn't affect content flow */}
      <Sidebar />
      {/* Main content - full width, with left padding for sidebar clearance */}
      <main className="pt-16 pl-16 min-h-screen">
        <div className="p-6">
          {children}
        </div>
      </main>
      {/* Command palette - global keyboard shortcut Cmd+K */}
      <CommandPalette isOpen={isOpen} onClose={close} />
    </div>
  )
}

export function Layout({ children }: LayoutProps) {
  return (
    <CommandPaletteProvider>
      <LayoutContent>{children}</LayoutContent>
    </CommandPaletteProvider>
  )
}
